/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Logout Button
 */
import { Button, ButtonProps } from 'antd';
import { Logout as LogoutIcon } from '@icon-park/react';

import { useKeycloak, logoutAndClearStorage } from 'lib/react-keycloak';

/**
 * Logout Button
 */
const Logout: React.FC<ButtonProps> = (props) => {
	const { keycloak } = useKeycloak();
	return (
		<Button type='primary' icon={<LogoutIcon />} onClick={() => logoutAndClearStorage({ keycloak })} {...props}>
			{'Logout'}
		</Button>
	);
};

export default Logout;
